module.exports = __webpack_public_path__ + "static/media/clinical_dosed_image.d3d91a6c.svg";